import { Component, OnInit, Input } from '@angular/core';
import { FormatoAsistencialEntity, ServicioFormatoAsistencialService, FiltrosFormatoAsistencialEntity } from '../../../services/servicio-formato-asistencial.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-firmas-formato',
  templateUrl: './firmas-formato.component.html',
  styleUrls: ['./firmas-formato.component.css']
})
export class FirmasFormatoComponent implements OnInit {

  @Input() public filtros: FiltrosFormatoAsistencialEntity;
  @Input() public encabezado: FormatoAsistencialEntity;
  @Input() public isProfesional: boolean;
  @Input() public isAfiliado: boolean;

  public firmaProfesional: string;
  public firmaAfiliado: string;

  constructor( private servicioFormato: ServicioFormatoAsistencialService) { }

  ngOnInit() {
    this.firmaProfesional = '';
    this.firmaAfiliado = '';
    if (this.isProfesional) { this.getFirmaProfesional(); }
    if (this.isAfiliado) { this.getFirmaAfiliado(); }
  }

  // Carga

  async getFirmaProfesional() {
    try {
      const response = await this.servicioFormato.getFirmaProfesional(this.filtros.codigoBaseDatos, {uncoProfesional : this.encabezado.profesionalEspecialidad.profesional.unco});
      if (response != null) {
        response.subscribe((data: any) => {
          this.firmaProfesional = data.source;
        }, (err: HttpErrorResponse) => {
          console.error('Error getFirmaProfesional()', err);
          this.firmaProfesional = '/assets/img/empty.png';
        });
      }
    } catch (e) {
      this.firmaProfesional = '/assets/img/empty.png';
      console.error('Catch getFirmaProfesional()', e);
    }
  }

  async getFirmaAfiliado() {
    const response = await this.servicioFormato.getFirmaAfiliado(this.filtros.codigoBaseDatos, { uncoEntidad: 1, uncoAfiliado: 241437});
    try {
      if (response != null) {
        response.subscribe((data: any) => {
          this.firmaAfiliado = data.source;
        }, (err: HttpErrorResponse) => {
          console.error('err getFirmaAfiliado()', err);
          this.firmaAfiliado = '/assets/img/empty.png';
        });
      }
    } catch (e) {
      this.firmaAfiliado = '/assets/img/empty.png';
      console.error('Catch getFirmaAfiliado()', e);
    }
  }

  // Auxiliares
  getNombresProfesional() {
    return this.encabezado.profesionalEspecialidad.profesional.nombres
      + ' ' + this.encabezado.profesionalEspecialidad.profesional.apellidos
      + ' - ' + this.encabezado.profesionalEspecialidad.profesional.registroMedico;
  }

  getEspecialidad() {
    return this.encabezado.profesionalEspecialidad.especialidad.descripcion;
  }

  getNombreAfiliado() {
    const apellido1 = this.encabezado.afiliado.primerApellido ? this.encabezado.afiliado.primerApellido : null;
    const apellido2 = this.encabezado.afiliado.segundoApellido ? this.encabezado.afiliado.segundoApellido : null;
    const nombre1 = this.encabezado.afiliado.primerNombre ? this.encabezado.afiliado.primerNombre : null;
    const nombre2 = this.encabezado.afiliado.segundoNombre ? this.encabezado.afiliado.segundoNombre : null;

    return `${apellido1} ${apellido2} ${nombre1} ${nombre2}`;
  }

  getNumeroIdentificacionAfiliado() {
    return this.encabezado.afiliado.tipoDocumento + ' - ' + this.encabezado.afiliado.numeroIdentificacion;
  }

}
